import type React from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { ScrollContainer } from '#src/app/shared/components/ScrollContainer';

import { PetitionStrengthCard, TipCard } from './components';
import { useGetPetitionStrengthTips } from './hooks/useGetPetitionStrengthTips';

export const StrengthTips: React.FC = () => {
	const {
		data: {
			score,
			featureConfigs: { strengthTipsEnabled },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { ownPetition },
	} = usePetitionDetailsPageUserData();

	const { tips, decisionMakerModal } = useGetPetitionStrengthTips();

	if (!strengthTipsEnabled) {
		return null;
	}

	if (!ownPetition) {
		return null;
	}

	if (tips.length === 0) {
		return null;
	}

	return (
		<div className="bg-background-raised">
			<div className="container pt-6 pb-3.5 md:pb-6">
				{/* Intentionally unlabelled and presentational: the score card names itself ("Petition strength" → "Score: N out of 10" → rating), so a region label or list semantics would only add repeated names and boundary noise ("region", "landmark", "list start"). */}
				<ScrollContainer
					data-qa="petition-strength-carousel"
					presentational
					backgroundColor="var(--color-background-raised)"
					className="w-max max-w-full pl-0 md:pl-2 [&>#scroll-container-list]:[scroll-padding-inline:16px] [&>#scroll-container-list]:pr-4 [&>#scroll-container-list]:pl-4 md:[&>#scroll-container-list]:[scroll-padding-inline:0px] md:[&>#scroll-container-list]:pr-2 md:[&>#scroll-container-list]:pl-0"
				>
					<PetitionStrengthCard score={score} />
					{tips.map((tip) => {
						return <TipCard key={`tip-card-${tip.type}`} tip={tip} />;
					})}
				</ScrollContainer>
			</div>
			{decisionMakerModal}
		</div>
	);
};
